
import { IconClock } from '@ds/icons/IconClock'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconThumbsDownOutlined } from '@ds/icons/IconThumbsDownOutlined'
import { mapGetters } from 'vuex'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './SatisfactionModal.translations'

export default {
  components: {
    FormattedMessage,
    IconRefund,
    IconClock,
    IconThumbsDownOutlined,
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
    }),

    showReturnsLine() {
      return this.$t(translations.returnTitle)
    },

    showPaymentsLine() {
      return this.$t(translations.paymentTitle)
    },
  },
}
